const ifScrolledToEndOfContainer = (scrollEvent = {}, config = {}) => {
  const { scrollWidth, scrollLeft, clientWidth } = scrollEvent;
  const { threshold } = config;

  if (!(scrollWidth && scrollLeft && clientWidth && threshold)) {
    return false;
  }

  return scrollWidth <= (threshold + scrollLeft + clientWidth);
};

export { ifScrolledToEndOfContainer }; // eslint-disable-line
